﻿import { RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';
import VeilederNordenDto from '../Models/VeilederNordenDto';

const ja = 'a1-betaleValgJa';
const nei = 'a2-betaleValgNei';

const betaleValg: RadioButtonValgModel<VeilederNordenDto>[] = [
    {
        id: 'betale-a1',
        value: ja,
        tekst: 'betaleValgJa',
    },
    {
        id: 'betale-a2',
        value: nei,
        tekst: 'betaleValgNei',
    },
];

export default {
    a1_ja: ja,
    a2_nei: nei,
    betaleValg,
};
